import React, { useState } from "react";
import { Button, Card, Checkbox, Form, message } from "antd";
import DatepickerRanger from "../toolbox/DatepickerRanger";
import strings from "../../utils/Localization";
import CariKartSelectOption from "../toolbox/CariKartSelectOption";
import DovizSelectOption from "../toolbox/DovizSelectOption";
import moment from "moment";
import { api } from "../../helpers/ApiHelper";
import useVarsayilanDeger from "../../hooks/useVarsayilanDeger"


export default function CariEkstreRaporForm() {
  const { cariEkstreRaporForm } = strings.cariEkstreRapor.components;
  const [form] = Form.useForm();
  const [fetchLoading, setFetchLoading] = useState(false);
  const {getDefaultSetting}= useVarsayilanDeger()
  
  const onFinish = async (values) => {
    try {
      const { tarih, cariKartId, dovizId, gecmisBakiyeDahilMi } = values;

      const baslangicTarihi = moment(tarih[0]).format("YYYY-MM-DD");
      const bitisTarihi = moment(tarih[1]).format("YYYY-MM-DD");

      setFetchLoading(true);
      const response = await api.post(
        "/rapordosya/cariekstre",
        {
          BaslangicTarih: `${baslangicTarihi} 00:00:00`,
          BitisTarih: `${bitisTarihi} 23:59:59`,
          CariKartId: cariKartId === undefined ? 0 : cariKartId,
          DovizId: dovizId === undefined ? 0 : dovizId,
          GecmisBakiyeDahilMi: gecmisBakiyeDahilMi,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        return window.open(response.data, "_blank");
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setFetchLoading(false);
    }
  };

  return (
    <Card>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{
          gecmisBakiyeDahilMi: true,
          tarih: [moment().add("months", -12), moment()],
          dovizId:getDefaultSetting("doviz")
        }}
      >
        <DatepickerRanger
          size="large"
          formName="tarih"
          formLabel={cariEkstreRaporForm.tarihSeciniz}
          required
        />
        <CariKartSelectOption formItemName="cariKartId" required allowClear />
        <DovizSelectOption formItemName="dovizId" required allowClear />
        <Form.Item name="gecmisBakiyeDahilMi" valuePropName="checked">
          <Checkbox>{cariEkstreRaporForm.gecmisBakiyeDahilEt}</Checkbox>
        </Form.Item>

        <Button
          type="primary"
          htmlType="submit"
          style={{ float: "right" }}
          size="large"
          loading={fetchLoading}
        >
          {cariEkstreRaporForm.raporAlButon}
        </Button>
      </Form>
    </Card>
  );
}
